import { formatCNPJ, onlyNumbers } from '@brazilian-utils/brazilian-utils';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { hasCompleteCnpjValue } from './CnpjOuNomeInput.utils';

function CnpjOuNomeInput(props) {
  const { value, onChange } = props;
  const enabledMask = hasCompleteCnpjValue(value);

  const handleChange = e => {
    const valueChanged = e.target.value;

    if (hasCompleteCnpjValue(valueChanged)) {
      onChange({
        ...e,
        target: {
          ...e.target,
          value: onlyNumbers(valueChanged),
        },
      });
    } else {
      onChange(e);
    }
  };

  return (
    <TextField type="text" {...props} onChange={e => handleChange(e)} value={enabledMask ? formatCNPJ(value) : value} />
  );
}

CnpjOuNomeInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CnpjOuNomeInput;
